module.exports = __webpack_public_path__ + "static/media/mountain.bdc50a30.svg";